import webStorage from '../../utils/webStorage';
import LogoutUserClient from '../../apiClients/user/logoutClient';

const initializer = (key, expDays) => function(data) {
  if (typeof data === 'undefined') {
    return webStorage.local.get(key, expDays);
  } else if(data === null) {
    webStorage.local.remove(key);
  } else {
    webStorage.local.set(key, data, expDays);
  }
};

const Storage = {
  customerToken: initializer('cusToken'),
  customerNumbers: initializer('customerNumbers'),
  serviceAddressesWithCustomerNumbers: initializer('serviceAddressesWithCustomerNumbers'),
  customerSummary: initializer('tg_cust'),
  selectedCustomer: initializer('tg_sel'),
  displayPayButtons: initializer('tg_pbut'),
  serviceFlag: initializer('tg_svcf'),
  emailPref: initializer('tg_email'),
  uid: initializer('tg_uid'),
  
  updateZip: initializer('tg_uzip__'),
  forgotPasswordEmail: initializer('tg_fpe__'),
  registrationSuccess: initializer('tg_regs__'),
  resetPasswordEmail: initializer('tg_rpe__'),
  easyPayEnroll: initializer('tg_ep__'),
  customQuote: initializer('tg_quo__'),
  
  loginUserName: initializer('tg_remme', 30),
  branchPref: initializer('tg_brpref', 15),
  plansAndServicesMenu: initializer('tg_menu', 15),
  customerReviews: initializer('tg_rev', 15),
};

Storage.customerNumber = () => (Storage.selectedCustomer() || {}).customerNumber;
Storage.serviceAddress = () => (Storage.selectedCustomer() || {}).serviceAddress;
Storage.customerSummaryObj = () => ((Storage.customerSummary() || {}).customers || []).filter(item => item.customerNumber === Storage.customerNumber())[0];
Storage.serviceAddressObj = () => ((Storage.customerSummaryObj() || {}).service_addresses || []).filter(item => item.address === Storage.serviceAddress())[0];
Storage.email = () => {
  const prefEmail = Storage.emailPref();
  const uid = Storage.uid();
  return prefEmail || uid || null;
};

Storage.displayPrePayButton = () => (Storage.displayPayButtons() || {}).prePay;
Storage.displayEasyPayButton = () => (Storage.displayPayButtons() || {}).easyPay;

Storage.zipCodePreference = () => (Storage.branchPref() || {}).zipcode;

Storage.logoutUser = async () => {
  try {
    await LogoutUserClient();
  } catch (error) {
    console.error('Error during logout API call:', error);
  } finally {
    // Clear local storage
    Storage.customerToken(null);
    Storage.customerNumbers(null);
    Storage.serviceAddressesWithCustomerNumbers(null);
    Storage.customerSummary(null);
    Storage.selectedCustomer(null);
    Storage.displayPayButtons(null); 
    Storage.easyPayEnroll(null);
    Storage.serviceFlag(null);
    Storage.emailPref(null);
    Storage.uid(null);
    Storage.updateZip(null);
  }
};

export default Storage;